import { Card } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import { Bar, BarChart, Legend, Tooltip, XAxis, YAxis } from 'recharts';
import type { DashboardMonth } from '../../../interfaces/dashboard/dashboardData';
import './EvolutionMensuellePanel.css';

interface EvolutionMensuellePanelProps {
	data: DashboardMonth[];
}

const formatMontantChart = (val: number) => formatMontant(val);

const EvolutionMensuellePanel = ({ data }: EvolutionMensuellePanelProps) => (
	<Card fluid>
		<Card.Content>
			<Card.Header content="Évolution mensuelle" />
			<Card.Description>
				<BarChart className="dashboardBarChart" data={data} responsive>
					<XAxis
						axisLine={false}
						dataKey={(item: DashboardMonth) => `${item.mois}/${item.annee}`}
					/>
					<YAxis
						axisLine={false}
						tickFormatter={formatMontantChart}
						width="auto"
					/>
					<Tooltip formatter={formatMontantChart} />
					<Legend />
					<Bar
						dataKey="ap"
						fill="#a61f43"
						name="APCP"
						radius={[10, 10, 0, 0]}
					/>
					<Bar
						dataKey="ae"
						fill="#006594"
						name="AECP"
						radius={[10, 10, 0, 0]}
					/>
				</BarChart>
			</Card.Description>
		</Card.Content>
	</Card>
);

export default EvolutionMensuellePanel;
